<template>
	<div class="qualityenterprise">
		<leftnav class="fl" mkcode="A" itemcode="A-QBQY"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="heightVh95 whitebox container-flex-center">
					<freeUserTips :type="4" :bgtype="0" isShowPageTitle="全部企业"></freeUserTips>
				</div> 
			</div>
		</div>
 
		 
	</div>
</template>

<script>
	import {
		dataInJs
	} from "../../utils/city.js";
	import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'enterpriseList',
		computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
		data() {
			return {
				title: "全部企业",
				fenkd:{children:[]},
				curindex: 6,comajaxurl:"",
				enterinarr: [
					{curindex: 1,type: 9,name: "上市公司",tagnum:10010,}, 
					{curindex: 2,type: 1,name: "龙头企业",tagnum:10010,},
					{curindex: 3,type: 2,name: "创新企业",tagnum:3,}, 
					{curindex: 4,type: 3,name: "优质企业",tagnum:10009},  
					],
				islogin: false,
				userdata: {},
				showscreen: true,
				notionCode:0, 
				searchtype: 0,searchTagnum:10010,
				searchtext: "",
				kwtextsearch: false,
				kwtextsearchtext: "", 
				flag: false,   
				page: 1, //显示的是哪一页
				haspage: true, //是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage: 1,
				maxPage: 10, //最大页数 
				provinceid: 0,
				cityid: 0,
				countyid: 0, 
				citydata: [],
				provincedata:dataInJs(),
				countydata: [],
				initialTagdata: [{
					tagName: "",tagCode: "",
					children: []
				}],  
				qyslitagCom: [],//公共科技实力
				qyslitagPublicselect:[],//公共科技实力下拉框版
				comSearchdata:[0,'empty','empty','empty'],//公共科技实力下拉框版 存储值
				qysltagUnique:[],//独有企业实力（全部企业集合 上市公司和优质企业的企业实力）
				//{tagCode:啊,type:'ss',tagName:的}, 
				totalqysl:[],
		 	searchtagdata: ['0'], 
				enterpristlist: [], 
				usertaglist: [], 
				num: 0,
				orderField: 0, //排序字段 0 分数 1 时间
				orderType: 0, //排序方式 0 降序 1 升序   
				commontagcode: 0,
				tyinitialTagdata: [],  
				exportnum: 0, //导出次数
				exportpop: false, //点击导出按钮弹框显示
				allowexport: false, //后台判断是否可以上传
				exportbtn: true, //loading小 等待转圈圈
				confirmtext: '确认导出',
				iframeurl: '',notionstep:0,
				// 0=分数,1=融资时间,2=企业实力,3=投资力度,4=本省关联度,5=拿地数量,6=拿地面积,7=拿地金额,8=投资项目数量,9=投资项目金额,10=控制企业数量,11=专利数量
				dimensionList: [
					{name:'综合',type:0},
					{name:'注册资本',type:21},
					{name:'迁址时间',type:22},
					{name:'拿地数量',type:5}, 
					{name:'拿地面积',type:6}, 	
					{name:'拿地金额',type:7}, 
					{name:'投资项目数量',type:8},
					{name:'投资项目金额',type:9},
					{name:'控制企业',type:10},
				
						],  
			}
		},
		beforeCreate() {
			// this.bus.$emit('loading', true);
		},  
		created() {
			
			 
		},
		mounted() {
		},
		methods: { 
			//单独的判断跳转链
		parkEnterpriseRouter(clycode,pid){
			let routeUrl = this.$router.resolve({
					path: '/enterprises',query: {id:clycode,pid:pid}
			});
			window.open(routeUrl.href, '_blank');  
		},
 getTableList(pages) {
 	this.bus.$emit('loading', true); 
 	this.page=pages?pages:1; 
 	var that = this; 
 	var notionja =this.splicing('notion',this.notionCode);
 	var kwaja =this.splicing('kw',this.searchtext); 
 	var countyidja =this.splicing('county',this.countyid); 
 	var ajaxurl=this.$api.park.enterprise.list()+'?search=1&page='+this.page+notionja+kwaja+countyidja+'&orderField='+this.orderField+'&orderType='+this.orderType; 
 	console.log(ajaxurl)
 	this.$axios.get(ajaxurl, {
 		headers: {
 			AuthToken: this.userdata.token
 		}
 	}).then(function(res) {
 		console.log('企业列表', res.data);
 		if (res.data.success) {
 			var dataenterlist= res.data.list; 
 			for (var i = 0; i < res.data.list.length; i++) {
 				var ddd=dataenterlist[i].financingRound;
 				dataenterlist[i].notionlist = that.taglistfun(dataenterlist[i].notion, dataenterlist[i].notionCode,'notionsort');
 				dataenterlist[i].taglist = that.taglistfun(dataenterlist[i].tag, dataenterlist[i].tagCode);  
 			} 
 			that.totalPage = res.data.totalPage;
 			that.pageSize = res.data.pageSize;
 			that.total = res.data.totalRecord;
 			that.haspage = res.data.list.length == res.data.pageSize; 
 			that.kwtextsearch = that.searchtext != "";
 			that.kwtextsearchtext = that.searchtext;
 			that.enterpristlist=dataenterlist;
 			that.bus.$emit('loading', false);
  
 		} else {
 			that.tokenfailed(res.data.msg);
 		}
 	}).catch(function(error) {});
 	// console.log(datas);  
 }, 
			//时间/分数升降序
			tablesort(field) {
				if (field == this.orderField) {
					this.orderType = Math.abs(this.orderType - 1);
				} else {
					this.orderField = field;
				}
				this.getTableList();
			},
			//搜索关键词
			searchkwfun() {
				this.searchtext = $.trim(this.searchtext);
				// if(this.searchtext!="" || ){
				this.getTableList(1);
				// } 
			},
			searchenter(e) {
				if (e.keyCode == 13) {
					this.searchkwfun();
				}
			}, 
			//选择标签
			choosetaglist1(obj, index) { 
				this.comSearchdata[index+1]=obj.target.value;
				console.log(this.comSearchdata);
				this.getTableList();
			},
   
			choosecounty(id) {
				//	console.log('choosecity',id);
				this.countyid = id;
				this.page = 1;
				this.getTableList();
			},  
			//概念单选 层级显示
			chooseNotion(chooseNotionlist,notionCode){ 
				this.notionCode=notionCode; 
				this.getTableList(1);
			},
		 
		}
	}
</script>

<style>
</style>
